// @ts-ignore
 
import request from "src/lib/axios";

/** 获取商户资料（含进件只读信息） GET /api/v1/dashboard/tenant/profile */
export async function DashboardTenantProfileControllerGetProfileV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputTenantProfileDto>(
    "/api/v1/dashboard/tenant/profile",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 更新商户可编辑资料 PUT /api/v1/dashboard/tenant/profile */
export async function DashboardTenantProfileControllerUpdateProfileV1(
  body: MyApi.UpdateTenantProfileDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputTenantProfileDto>(
    "/api/v1/dashboard/tenant/profile",
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}
